import type { SspComponentResponse } from "../../../../api/frameworksApi";
import type { SspLayerKey } from "../constants";

// Determine which SSP layer a component belongs to.
// Prefers sspLayerSlug from API, then explicit "Layer" / "SSP Layer" / "Group Name" props, then maps by componentType.
export function getComponentLayer(comp: SspComponentResponse): SspLayerKey {
  // First: use sspLayerSlug directly from the API response
  if (comp.sspLayerSlug) {
    const slug = comp.sspLayerSlug.toLowerCase().trim();
    if (slug === "application") return "application";
    if (slug === "data") return "data";
    if (slug === "runtime") return "runtime";
    if (slug === "compute") return "compute";
    if (slug === "storage") return "storage";
    if (slug === "platform" || slug === "datacenter") return "platform";
    if (slug === "network") return "network";
  }

  const propLayer =
    comp.props?.find(
      (p) =>
        p.name?.toLowerCase() === "layer" ||
        p.name?.toLowerCase() === "ssp layer" ||
        p.name?.toLowerCase() === "ssp-layer",
    )?.value ||
    comp.props?.find((p) => p.name === "Group Name")?.value ||
    "";
  const norm = propLayer.toLowerCase().replace(/\s*ssp\s*/g, "").trim();
  if (norm.includes("application")) return "application";
  if (norm.includes("data")) return "data";
  if (norm.includes("runtime")) return "runtime";
  if (norm.includes("compute")) return "compute";
  if (norm.includes("storage")) return "storage";
  if (norm.includes("datacenter") || norm.includes("platform"))
    return "platform";
  if (norm.includes("network")) return "network";

  const t = (comp.componentType || "").toLowerCase();
  if (t === "hardware") return "compute";
  if (t === "service") return "application";
  if (
    t === "software" ||
    t === "policy" ||
    t === "process" ||
    t === "procedure" ||
    t === "plan" ||
    t === "guidance" ||
    t === "standard" ||
    t === "validation"
  )
    return "application";
  return "application";
}

export function getControlCountLabel(comp: SspComponentResponse): string {
  const mapped = comp.implementedControlCount ?? 0;
  const confirmed = comp.fullyImplementedControlCount ?? 0;
  if (comp.displayStatus === "CONTROLS_ASSIGNED" && mapped > 0) {
    if (confirmed > 0) {
      return `${confirmed} of ${mapped} controls implemented`;
    }
    return `${mapped} ${mapped === 1 ? "control" : "controls"} assigned`;
  }
  return `${mapped} Controls`;
}
